module.exports = __webpack_public_path__ + "img/link-primary.6890935.png";